<template>
  <div class="forgot">
    <div class="logo">
      <img src="https://cdn.lessonplan.cn/Public/Logo/logo_old.png" alt="logo">
      <h1>课玩<span> 端应用</span></h1>
      <p>你可以在你的世界里迷失，但不要忘记找回自我</p>
    </div>

    <div class="forgot-form main-login">
      <template v-if="step === 1">
        <input v-model="username" type="text" placeholder="请输入手机号码" class="username">
        <div class="code-box">
          <input v-model="code" type="text" placeholder="请输入验证码" class="code" />
          <button v-if="count === 0" class="code-btn" @click="getPhoneCode()">获取验证码</button>
          <button v-else class="code-btn" disabled>{{ count }}秒后重试</button>
        </div>
        <button class="forgot-btn" @click="startVerify">下一步</button>
      </template>

      <template v-if="step === 2">
        <input v-model="password" type="password" placeholder="设置密码" class="password" />
        <input v-model="repeatPassword" type="password" placeholder="重复密码" class="password" />
        <button class="forgot-btn" @click="setNewPassword">确 定</button>
      </template>

      <div class="go-login">已有帐号? <a @click="goLogin()">去登录</a></div>
    </div>
  </div>
</template>

<script>
import { hasMysqlUtf8UnsupportedChar } from '../../util/validate'

export default {
  name: 'forgot',
  props: {
    redirectURI: String,
  },
  data() {
    return {
      userGuid: '',
      username: '',
      code: '',
      codeGuid: '',
      password: '',
      repeatPassword: '',
      step: 1,
      count: 0,
      countTime: null
    }
  },
  methods: {
    async startVerify() {
      if (!this.username) {
        return this.$message.warning('请填写您要找回的账号')
      }
      if (!/^1[3456789]\d{9}$/.test(this.username)) {
        return this.$message.warning('请输入合法的手机号')
      }
      if (!this.code) {
        return this.$message.warning('请输入验证码')
      }
      if (!this.codeGuid) {
        return this.$message.warning('请先获取验证码')
      }

      const checkCodeRet = await this.$api.account.checkcode(this.codeGuid, this.code)
      if (checkCodeRet.code !== 1) {
        this.code = ''
        this.codeGuid = ''
        return this.$message.warning(checkCodeRet.msg || '验证码错误')
      }

      const userList = await this.$api.account.getClientByUser(this.username).then(ret => ret.data || [])
      if (userList.length === 0) {
        return this.$message.warning('未找到该用户，请确认手机号是否正确')
      }
      this.userGuid = userList[0].PK_UserGuid
      this.$message.success('验证通过，请设置新密码')
      this.step++
    },

    async setNewPassword() {
      if (!this.password || !this.repeatPassword) {
        return this.$message.warning('请填写您的新密码')
      }
      if (this.password !== this.repeatPassword) {
        return this.$message.warning('两次密码输入不一致')
      }
      if (
        hasMysqlUtf8UnsupportedChar(this.username) ||
        hasMysqlUtf8UnsupportedChar(this.password)
      ) {
        return this.$message.warning('用户名或密码不能包含 emoji、生僻字等特殊字符')
      }

      const setNewPasswordRet = await this.$api.account.setNewPassword({
        PK_UserGuid: this.userGuid,
        Password: this.password
      })
      if (setNewPasswordRet.status === 1) {
        this.$message.success('新密码设置成功')
        this.$router.push('/')
      }
    },

    goLogin() {
      this.$router.push({ name: 'login', query: { redirectURI: this.redirectURI } })
    },

    async getPhoneCode() {
      if (!/^1[3456789]\d{9}$/.test(this.username)) {
        return this.$message.warning('请输入合法的手机号')
      }

      this.count = 60
      this.countTime = setInterval(() => {
        this.count -= 1
        if (this.count === 0) {
          clearInterval(this.countTime)
          this.countTime = null
        }
      }, 1000)

      const sendSmsRet = await this.$api.account.sendSms(this.username)
      if (sendSmsRet.code !== 1 || !sendSmsRet.data || !sendSmsRet.data.PK_CodeGuid) {
        clearInterval(this.countTime)
        this.countTime = null
        this.count = 0
        return this.$message.warning(sendSmsRet.msg || '验证码发送失败')
      }
      this.codeGuid = sendSmsRet.data.PK_CodeGuid
      this.$message.success('短信已发送，请注意查收')
    },
  }
}
</script>

<style lang="scss" scoped>
.forgot {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    margin-left: 16px;
    width: 88px
  }

  h1 {
    font-size: 28px;
    color: #555;
    margin-top: 8px;

    span {
      font-size: 17px;
    }
  }

  p {
    width: 270px;
    text-align: center;
    font-size: 15px;
    color: #888;
    margin-top: 5px;
    margin-bottom: 12px;
  }
}

.forgot-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .code-box {
    width: 270px;
    display: flex;
    align-items: center;
    margin: 5px 0;

    input {
      flex: 1;
      width: auto;
      margin: 0;
    }

    .code-btn {
      width: 80px;
      margin: 0 0 0 8px;
      font-size: 11px;
      padding: 0;
    }
  }

  .go-login {
    font-size: 14px;
    color: #666666;
    margin-top: 20px;

    a {
      color: #f77f90;
    }
  }
}
</style>
